import { DANH_MUC } from "../const/danh-muc";

export class DanhMucUtil {
    private static danh_mucs = {

    }

    /**
     * lấy tên danh mục dựa vào id
     */
    static getsNameByID = (id, name) => {
        // console.log(id, name);
        // console.log(DanhMucUtil.danh_mucs[id]);
        if (DanhMucUtil.danh_mucs[id])
            return DanhMucUtil.danh_mucs[id];
        return name;
    }
}